import { QUARTER_OPTIONS_TRANSLATE } from 'constants/translate'
import { EQuarter } from 'enums/common'

export const renderBarLegend = (props: any) => {
  const { payload } = props
  return (
    <ul className='flex justify-center gap-4 mt-4'>
      {payload.map((entry: any, index: number) => {
        return (
          <li key={`item-${index}`} className='flex gap-2 items-center'>
            <div className={'w-[0.75rem] h-[0.75rem] rounded-sm'} style={{ background: entry.color }} />
            <span className='font-normal text-xs text-black-450'>
              {QUARTER_OPTIONS_TRANSLATE[entry.value as EQuarter] || 'Overall'}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
